/**
 * YouelecLogo — Logo officiel YouElec (Option B : Dark Premium)
 * - Toit / arches : Or #D4AF37
 * - Stem du "Y" + texte "Youelec" : Crème #F8FAFC
 * - Fond : transparent (s'intègre au thème Navy #050B14)
 *
 * Variants:
 *   - "mark"   : icône seule (carré)
 *   - "wordmark" : "Youelec" texte seul
 *   - "full"   : icône + texte (horizontal)  [par défaut]
 *   - "stack"  : icône au-dessus + texte en dessous (centré)
 */

const GOLD = "#D4AF37";
const CREAM = "#F8FAFC";

function LogoMark({ size = 40, className = "", glow = true, ...rest }) {
  return (
    <svg
      viewBox="0 0 64 64"
      width={size}
      height={size}
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      data-testid="youelec-logo-mark"
      {...rest}
    >
      {glow && (
        <defs>
          <filter id="yl-glow" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="1.4" result="blur" />
            <feMerge>
              <feMergeNode in="blur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>
      )}
      {/* Toit / arches du Y — Or */}
      <path
        d="M 6 28 L 32 6 L 58 28"
        stroke={GOLD}
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
        filter={glow ? "url(#yl-glow)" : undefined}
      />
      {/* Stem du Y — Crème */}
      <path
        d="M 32 7 L 32 58"
        stroke={CREAM}
        strokeWidth="6"
        strokeLinecap="round"
      />
    </svg>
  );
}

function WordMark({ className = "", as: Tag = "span", ...rest }) {
  return (
    <Tag
      className={`font-display font-extrabold tracking-tighter ${className}`}
      data-testid="youelec-logo-wordmark"
      style={{ color: CREAM }}
      {...rest}
    >
      You<span style={{ color: GOLD }}>elec</span>
    </Tag>
  );
}

export default function YouelecLogo({
  variant = "full",
  size = 40,
  textSize = "text-xl",
  className = "",
  glow = true,
}) {
  if (variant === "mark") {
    return <LogoMark size={size} className={className} glow={glow} />;
  }
  if (variant === "wordmark") {
    return <WordMark className={`${textSize} ${className}`} />;
  }
  if (variant === "stack") {
    return (
      <div
        className={`flex flex-col items-center gap-2 ${className}`}
        data-testid="youelec-logo-stack"
      >
        <LogoMark size={size} glow={glow} />
        <WordMark className={textSize} />
      </div>
    );
  }
  // full (default) : icône + texte horizontal
  return (
    <div
      className={`flex items-center gap-3 ${className}`}
      data-testid="youelec-logo-full"
    >
      <LogoMark size={size} glow={glow} />
      <WordMark className={textSize} />
    </div>
  );
}

export { LogoMark, WordMark };
